const medscape = window.medscape || { configs: {} };
const configs = medscape.configs || { medias: [] };
let medias = configs.medias || [];
//console.log("medias:",medias);
if (medias.length === 0) {
  medias = [
    {
      host: "webmd-vh.akamaihd.net",
      endpoint: "/i/delivery",
      type: "application/x-mpegURL",
      file: ".csmil/master.m3u8"
    },
    {
      host: "webmd-a.akamaihd.net",
      endpoint: "/delivery",
      type: "video/mp4",
      file: "750k.mp4",
    },
    {
      host: "webmd-a.akamaihd.net",
      endpoint: "/delivery",
      type: "audio/mpeg",
      file: "a96k.mp4",
    },
  ];
}
export default medias;
